import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getList,
  addData,
  editData,
  deleteData,
} from "../../helpers/fackBackend_Helper";

function* getAnnouncementListResponse() {
  try {
    const response = yield call(getList, "/getAnnouncement");
    if (response.response.Status) {
      yield put(actions.getAnnouncementSuccess(response.response.Data));
    } else {
      yield put(actions.getAnnouncementFailed());
    }
  } catch (error) {
    yield put(actions.getAnnouncementFailed());
  }
}

function* addAnnouncementResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/addAnnouncement", data);
    if (response.Status) {
      const responseList = yield call(getList, "/getAnnouncement");
      if (responseList.response.Status) {
        yield put(
          actions.addAnnouncementSuccess(
            response.Message,
            responseList.response.Data,
          ),
        );
      } else {
        yield put(actions.addAnnouncementFailed(response.response.Message));
      }
    } else {
      yield put(actions.addAnnouncementFailed(response.Message));
    }
  } catch (error) {
    yield put(actions.addAnnouncementFailed(error.Message));
  }
}

function* deleteAnnouncementResponse({ payload: { announcementId, status } }) {
  try {
    const response = yield call(
      deleteData,
      "/deleteAnnouncement/" + announcementId + "/" + status,
    );
    if (response.Status) {
      const responseList = yield call(getList, "/getAnnouncement");
      if (responseList.response.Status) {
        yield put(
          actions.deleteAnnouncementSuccess(
            response.Message,
            responseList.response.Data,
          ),
        );
      } else {
        yield put(actions.getAnnouncementFailed(response.response.Message));
      }
    } else {
      yield put(actions.getAnnouncementFailed(response.response.Message));
    }
  } catch (error) {
    yield put(actions.addAnnouncementFailed(error));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_ANNOUNCEMENT, getAnnouncementListResponse)]);
  yield all([takeEvery(actions.ADD_ANNOUNCEMENT, addAnnouncementResponse)]);
  yield all([
    takeEvery(actions.DELETE_ANNOUNCEMENT, deleteAnnouncementResponse),
  ]);
}
